export default __webpack_public_path__ + "static/FS2S-InHub-131-4fcd678d317fd5191076fc5c9ccbc314.jpg";